import { render } from "./SearchObjectToLinkComponent.vue?vue&type=template&id=1c01c86b&scoped=true"
import script from "./SearchObjectToLinkComponent.vue?vue&type=script&lang=js"
export * from "./SearchObjectToLinkComponent.vue?vue&type=script&lang=js"

import "./SearchObjectToLinkComponent.vue?vue&type=style&index=0&id=1c01c86b&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c01c86b"]])

export default __exports__